import { render, staticRenderFns } from "./TaskNotifications.vue?vue&type=template&id=4b07d159&"
import script from "./TaskNotifications.vue?vue&type=script&lang=js&"
export * from "./TaskNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports